import React from 'react'
import ContentVehicleMultiCardListing from '../../../components/ContentVehicleMultiCardListing'
import ContentSectionHeading from '../../../components/ContentSectionHeading'
import LinkRounded from '../../../components/LinkRounded'
import { Text } from 'rebass'
import getBrandLogo from '../../../../lib/make/brand-logo-mapper'
import createModelNormaliser from '../../../../lib/model/model-to-vehicle-card-normaliser'

const FullWidget = ({ models }) => {
  const normalisedModels = models.map((model) => {
    const normaliseModelForVehicleCard = createModelNormaliser(model.make)
    return normaliseModelForVehicleCard(model)
  })
  const makePath = `/${models[0].make.slug}`
  return (
    <div>
      <ContentSectionHeading
        brand={getBrandLogo(models[0].make)}
        title={`Browse our ${models[0].make.name} range`}
      />
      <ContentVehicleMultiCardListing vehicles={normalisedModels} />
      <Text center as="div">
        <LinkRounded to={makePath} shadow thin outline>
          See the full range
        </LinkRounded>
      </Text>
    </div>
  )
}

export default FullWidget
